<template>
  <b-row class="d-flex justify-content-around p-2">
    <b-col md="10" class="bg-white text-left">
      <h3>Registra un audio</h3>

      <div class="toggle btn btn-primary" @click="toggle">COMMUTA ASCOLTA/REGISTRA</div>

      <audio-recorder
        v-if="showRecorder"
        :upload-url="uploadUrl"
        filename="audiokbc"
        format="mp3"
        :attempts="3"
        :time="3"
        :headers="headers"
        :before-recording="callback"
        :pause-recording="callback"
        :after-recording="uploadAudio"
        :select-record="callback"
        :before-upload="callback"
        :successful-upload="callback"
        :failed-upload="callback"
        :bit-rate="96"
      />

      <audio-player :src="mp3" v-if="!showRecorder" />
    </b-col>
  </b-row>
</template>

<script>
import authFileHeader from "@/services/auth-header";

export default {
  name: "Audio",
  data() {
    return {
      mp3: "/example.mp3",
      showRecorder: true,
    };
  },
  methods: {
    callback(msg) {
      console.log("Event: ", msg);
    },
    toggle() {
      this.showRecorder = !this.showRecorder;
    },
    uploadAudio(msg) {
      console.log(msg);
      const data = new FormData();
      data.append("reviewed", msg.blob, "audio.mp3");

      this.axios({
        method: "post",
        url: process.env.VUE_APP_ROOT + "/documents/uploadRevision/1",
        data: data,
        headers: authFileHeader(),
      })
        .then((resp) => {
          this.$eventBus.$emit("end-upload", { status: "success", response: resp });
        })
        .catch((error) => {
          this.$eventBus.$emit("end-upload", { status: "fail", response: error });
        });
    },
  },
  computed: {
    uploadUrl: function () {
      return process.env.VUE_APP_ROOT + "/documents/uploadAudio/1";
    },
  },
};
</script>

<style lang="scss">
.toggle {
  cursor: pointer;
  margin: 20px;
}
</style>
